module.exports = __webpack_public_path__ + "img/1010.9533799b.svg";